<script setup lang="ts">
import { twMerge } from 'tailwind-merge';
import type { ButtonHTMLAttributes } from 'vue';

type Color = 'red' | 'yellow' | 'pink' | 'white';
interface Props extends /* @vue-ignore */ ButtonHTMLAttributes {
  color?: Color;
}
const props = withDefaults(defineProps<Props>(), {
  color: 'red',
});
const className = computed(() =>
  twMerge(`button button--${props.color}`, props.class),
);
</script>

<template>
  <button :class="className" aria-label="ゲームスタート" />
</template>

<style scoped>
.button {
  display: block;
  width: 343px;
  height: 58px;
}

.button.button--red {
  background-image: url(/images/button/game_start_button_red.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.button.button--yellow {
  background-image: url(/images/button/game_start_button_yellow.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.button.button--pink {
  background-image: url(/images/button/game_start_button_pink.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.button.button--white {
  background-image: url(/images/button/game_start_button_white.png);
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
